export default function shareItems(arr) {
	const result = [];
	arr.forEach(element => {
		result.push(element[0]);
	});
	return result;
}
